import * as types from '../types';
  
  const initialState = {
    access_token: localStorage.getItem("token"),
    isAuthenticated: JSON.parse(localStorage.getItem('data') || '{}'),
    loading: false,
    data: null,
    isError: false,
    errorInfo: null,
    username: localStorage.getItem("username") || '',
  };
  
  const userReducer = (state = initialState, action:any) => {
    const { type, payload, message } = action;
    switch (type) {
      case types.LOGIN_BEGIN:
        return {
          ...state,
          loading: true,
          isAuthenticated: false,
          data: null,
          errorInfo: null,
        };

      case types.LOGIN_SUCCESS:
        localStorage.setItem("token", payload?.data?.accessToken);
        // localStorage.setItem("data", JSON.stringify(payload));
        return {
          ...state,
          ...payload,
          loading: false,
          data: payload,
          errorInfo: null,
        };

      //case types.LOGOUT:
      case types.LOGIN_FAILURE:
        // localStorage.removeItem("token");
        // localStorage.removeItem("data");
        localStorage.clear();
        // setTimeout(() => {
        //   (window.location.href = "/");
        // }, 2000)
        return {
          ...state,
          access_token: null,
          loading: false,
          isError: true,
          data: '{}',
          errorInfo: message
        };

        case types.RESET:
          return {
            access_token: null,
            loading: false,
            isError: true,
            data: null,
            isAuthenticated: false,
            username: '',
            errorInfo: null,
          }
      default:
        return state;
    }
  }

  export default userReducer;